import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 12px;
`
const Text = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const IconStyled = styled(Icon)`
  margin-right: 10px;
  color: ${props => props.value ? '#2e964b' : '#4c4c4c'}
`

class StatusBar extends Component {
  constructor(props) {
    super(props)
    this.state = {};
  }

  render() {
    const { value, text } = this.props;
    return (
      <Container>
        <IconStyled value={value}>{value ? 'check_box' : 'remove'}</IconStyled>
        <Text>{text}</Text>
      </Container>
    );
  }
}

StatusBar.propTypes = {
  value: PropTypes.bool,
  text: PropTypes.string,
}

StatusBar.defaultProps = {

}

export default StatusBar;
